import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import Formikform from "../../../../Components/ExtraComponents/Form/Formik_form1";
import { useFormik } from "formik";
import * as valid_err from "../../../../Utils/Common_Messages";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Email_regex,
  Mobile_regex,
  Name_regex,
} from "../../../../Utils/Common_regex";
import { useDispatch, useSelector } from "react-redux";
import Content from "../../../../Components/Dashboard/Content/Content";
import {
  GET_ALL_GROUP_SERVICES,
  Find_One_User,
  Update_User,
} from "../../../../ReduxStore/Slice/Admin/AdminSlice";
import { Get_All_SUBADMIN } from "../../../../ReduxStore/Slice/Subadmin/Subadminslice";
import { Get_All_Service_for_Client } from "../../../../ReduxStore/Slice/Common/commoSlice";
import { Get_Service_By_Group_Id } from "../../../../ReduxStore/Slice/Admin/GroupServiceSlice";
import { check_Device } from "../../../../Utils/find_device";
import toast, { Toaster } from "react-hot-toast";
import ToastButton from "../../../../Components/ExtraComponents/Alert_Toast";
import "../../../../App.css";
import { f_time } from "../../../../Utils/Date_formet";
import { GET_IP } from "../../../../Service/common.service";
const user_details = JSON.parse(localStorage.getItem("user_details")) || {};


const EditClient = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [ip, setIp] = useState("");

  useEffect(() => {
    GET_IP().then((response) => {
      setIp(response.data.ip);
    });
  }, []);

  const permission = JSON.parse(localStorage.getItem("permission"));

  const selector = useSelector((state) => state.DashboardSlice);
  const [UserData, setUserData] = useState({ loading: true, data: [] });
  const [selectedStrategies, setSelectedStrategies] = useState([]);
  const [ShowAllStratagy, setShowAllStratagy] = useState(true);

  const [first, setfirst] = useState([]);
  const [Addsubadmin, setAddsubadmin] = useState({ loading: true, data: [] });
  const [AllStrategy, setAllStrategy] = useState({ loading: true, data: [] });
  const [GetServices, setGetServices] = useState({ loading: true, data: [] });
  const [selectedPlan, setSelectedPlan] = useState("");
  const [AllGroupServices, setAllGroupServices] = useState({
    loading: true,
    data: [],
  });

  const isValidEmail = (email) => {
    return Email_regex(email);
  };
  const isValidContact = (mobile) => {
    return Mobile_regex(mobile);
  };

  const isValidName = (mobile) => {
    return Name_regex(mobile);
  };

  // GET USER DETAILS
  const data_1 = async () => {
    await dispatch(Find_One_User({ id: location.state._id }))
      .unwrap()
      .then((response) => {
        if (response.status) {
          setUserData({
            loading: false,
            data: response,
          });

          setSelectedPlan(response.data[0].plan_id);
        }
      });
  };

  useEffect(() => {
    data();
    data_1();
  }, []);

  const formik = useFormik({
    initialValues: {
      username: null,
      fullName: null,
      email: null,
      mobile: null,
      broker: null,
      licence: null,
      groupservice: null,
      parent_id: null,
      strategies: [],
      tomonth: null,
      todate: null,
      fromDate: null,
      app_id: "null",
      api_type: "null",
      client_code: "null",
      api_key: "null",
      api_secret: "null",
      app_key: "null",
      demat_userid: "null",
      parent_role: null,
      Strategy: false,
      licence1: "null",
      multiple_strategy_select: false,
      network_ip: ip,
      Serivcecharge: 0,
      Received: 0,
    },

    validate: (values) => {
      const errors = {};
      if (!values.username) {
        errors.username = valid_err.USERNAME_ERROR;
      }
      if (!values.fullName) {
        errors.fullName = valid_err.FULLNAME_ERROR;
      } else if (!isValidName(values.fullName)) {
        errors.fullName = valid_err.INVALID_ERROR;
      }
      if (!values.mobile) {
        errors.mobile = valid_err.CONTACT_ERROR;
      } else if (!isValidContact(values.mobile)) {
        errors.mobile = valid_err.INVALID_CONTACT_ERROR;
      }
      if (!values.licence) {
        errors.licence = valid_err.LICENCE_TYPE_ERROR;
      } else if (values.licence === "2" || values.licence === 2) {
        if (!values.broker) {
          errors.broker = valid_err.BROKER_ERROR;
        }
      } else if (values.licence === "0" || values.licence === 0) {
        if (!values.broker) {
          errors.broker = valid_err.BROKER_ERROR;
        }
      }
      if (!values.groupservice) {
        errors.groupservice = valid_err.GROUPSELECT_ERROR;
      }
      if (selectedStrategies.length === 0) {
        errors.Strategy = "select strategy";
      }

      if (!values.email) {
        errors.email = valid_err.EMPTY_EMAIL_ERROR;
      } else if (!isValidEmail(values.email)) {
        errors.email = valid_err.INVALID_EMAIL_ERROR;
      }

      if (values.licence == "2") {
        if (!values.broker) {
          errors.broker = valid_err.BROKER_ERROR;
        }
      }

      return errors;
    },
    onSubmit: async (values) => {
      if (values.licence == 2) {
        if (values.licence1 == null) {
          if (
            values.tomonth == null ||
            values.tomonth == "" ||
            values.tomonth == undefined ||
            values.tomonth == "0"
          ) {
            toast.error("Please Select Licence");
            return;
          }
        }
      }

      const req = {
        FullName: values.fullName,
        UserName: values.username,
        Email: values.email,
        PhoneNo: values.mobile,
        licence1: values.tomonth,
        license_type: values.licence,
        Strategies: selectedStrategies.filter((item) => item.checked === true),
        fromdate: values.fromDate,
        todate: values.todate,
        service_given_month: 0,
        broker: values.broker,
        parent_id:
          values.parent_id == null || values.parent_id === ""
            ? user_details.user_id
            : values.parent_id,
        parent_role:
          values.parent_id == null || values.parent_id === ""
            ? "ADMIN"
            : "SUBADMIN",
        api_secret: values.api_secret,
        app_id: values.app_id,
        client_code: values.client_code,
        api_key: values.api_key,
        app_key: values.app_key,
        api_type: values.api_type,
        demat_userid: values.demat_userid,
        group_service: values.groupservice,
        licence: values.licence1,
        Editor_role: user_details?.Role,
        device: check_Device(),
        multiple_strategy_select:
          values.multiple_strategy_select === false ? "0" : "1",
        network_ip: ip,
        plan_id: selectedPlan,
        Serivcecharge: values?.Serivcecharge || 0,
        Received: values?.Received || 0,
        invoice_Permission: 0,
      };
      Swal.fire({
        title: "Confirm Update",
        width: "70%",
        html: `
  <div style="text-align:left; font-size: 14px; line-height: 1.5; display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px;">
    
    ${values.username ? `<div><b>Username:</b> ${values.username}</div>` : ""}
    ${values.fullName ? `<div><b>Full Name:</b> ${values.fullName}</div>` : ""}
    ${values.email ? `<div><b>Email:</b> ${values.email}</div>` : ""}
    ${values.mobile ? `<div><b>Phone:</b> ${values.mobile}</div>` : ""}

    ${
      values.licence !== undefined && values.licence !== null
        ? `<div><b>Licence:</b> ${
            values.licence == 0
              ? "2 Days"
              : values.licence == 1
              ? "Demo"
              : values.licence == 2
              ? "Live"
              : "-"
          }</div>`
        : ""
    }

    ${
      values.licence !== "1" && values.licence !== 1 && values.broker
        ? `<div><b>Broker:</b> ${
            values.broker == "1"
              ? "CoinDcx"
              : values.broker == "2"
              ? "DeltaExchange"
              : values.broker == "3"
              ? "Binance"
              : values.broker == "4"
              ? "Zebpay"
              : values.broker == "5"
              ? "Coin Switch"
              : values.broker == "6"
              ? "Pi42"
              : null
             
          }</div>`
        : ""
    }

    ${values.fromDate ? `<div><b>From Date:</b> ${values.fromDate}</div>` : ""}
    ${values.todate ? `<div><b>To Date:</b> ${values.todate}</div>` : ""}

    ${
      values.groupservice
        ? `<div><b>Selected Group Service:</b> ${
            AllGroupServices?.data.find(
              (item) => values.groupservice === item._id
            )?.name ?? "N/A"
          }</div>`
        : ""
    }

    <div style="grid-column: span 3;">
      <b>All Group Services:</b><br/>
      <div style="display: flex; flex-wrap: wrap; gap: 8px; margin-top: 5px;">
        ${
          GetServices?.data?.length
            ? GetServices.data
                .map(
                  (strategy) => `
                  <span style="
                    display: inline-block;
                    border: 1px solid #ccc;
                    padding: 4px 10px;
                    border-radius: 20px;
                    font-size: 13px;
                  ">
                    ${strategy.ServiceResult.name} [${
                    strategy.categories?.category ?? "N/A"
                  }]
                  </span>`
                )
                .join("")
            : "No Services Found"
        }
      </div>
    </div>

    <div style="grid-column: span 3;">
      <b>Selected Strategies:</b><br/>
      <div style="display: flex; flex-wrap: wrap; gap: 8px; margin-top: 5px;">
        ${
          selectedStrategies?.filter((s) => s.checked).length
            ? selectedStrategies
                .filter((s) => s.checked)
                .map(
                  (s) => `
                <span style="
                  display: inline-block;
                  border: 1px solid #ccc;
                  padding: 4px 10px;
                  border-radius: 20px;
                  font-size: 13px;
                ">${s.name}</span>`
                )
                .join("")
            : "No Strategy Selected"
        }
      </div>
    </div>

  </div>
  `,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, update it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await dispatch(Update_User({ req: req, token: user_details.token }))
            .unwrap()
            .then((response) => {
              if (response.status === 409) {
                toast.error(response.data.msg);
              } else if (response.status) {
                toast.success(response.msg);
                navigate("/admin/allclients");
              } else {
                toast.error(response.msg);
              }
            });
        } else {
          return false;
        }
      });
    },
  });

  let fields = [
    {
      name: "username",
      label: "Username",
      type: "text",
      label_size: 12,
      col_size: 4,
      disable: true,
      madatory: true,
    },
    {
      name: "fullName",
      label: "FullName",
      type: "text",
      label_size: 12,
      col_size: 4,
      disable: true,
      madatory: true,
    },
    {
      name: "email",
      label: "Email",
      type: "text",
      label_size: 12,
      col_size: 4,
      disable: true,
      madatory: true,
    },
    {
      name: "mobile",
      label: "Mobile",
      type: "number",
      label_size: 12,
      col_size: 4,
      disable: true,
      madatory: true,
    },
    {
      name: "licence",
      label: "Licence",
      type: "select",
      options:
        UserData?.data?.data !== undefined &&
        UserData.data.data[0].license_type === "2"
          ? [{ label: "Live", value: "2" }]
          : UserData?.data?.data !== undefined &&
            UserData.data.data[0].license_type === "0"
          ? [
              permission.Two_day_client == 1
                ? { label: "2 Days", value: "0" }
                : null,
              { label: "Live", value: "2" },
            ].filter(Boolean)
          : [
              permission.Two_day_client == 1
                ? { label: "2 Days", value: "0" }
                : null,
              { label: "Demo", value: "1" },
              { label: "Live", value: "2" },
            ].filter(Boolean),
      label_size: 12,
      col_size: 4,
      disable:
        UserData.data.data !== undefined &&
        UserData.data.data[0].license_type === "2"
          ? true
          : false,
      madatory: true,
    },
    // {
    //   name: "licence1",
    //   label: "Use License Month",
    //   type: "text",
    //   label_size: 12,
    //   col_size: 4,
    //   disable: true,
    //   showWhen: (values) => values.licence === "2",
    //   madatory: true,
    // },
    {
      name: "tomonth",
      label: "To Month",
      type: "select",
      options:
        first &&
        first?.map((item) => ({ label: item.endDate, value: item.month })),
      showWhen: (values) => values.licence === "2",
      label_size: 12,
      col_size: 4,
      disable: false,
      isSelected: true,
    },
    {
      name: "broker",
      label: "Broker",
      type: "select",
      options: permission?.broker_id?.map((item) => ({
        label: item.name,
        value: item.id,
      })),
      showWhen: (values) => values.licence === "2" || values.licence === "0",
      label_size: 12,
      col_size: 4,
      disable: false,
      madatory: true,
    },
    //  For Demo Only Client
    {
      name: "fromDate",
      label: "From Date",
      type: "date1",
      showWhen: (values) => values.licence === "1",
      label_size: 12,
      col_size: 4,
      disable: true,
      madatory: true,
    },
    {
      name: "todate",
      label: "To Date",
      type: "date1",
      showWhen: (values) => values.licence === "1",
      label_size: 12,
      col_size: 4,
      disable: false,
      madatory: true,
    },
    {
      name: "api_key",
      label: "Api Key",
      type: "text",
      showWhen: (values) =>
        values.broker === "1" ||
        values.broker === "2" ||
        values.broker === "3" ||
        values.broker === "4" ||
        values.broker === "5" ||
        values.broker === "6",
      label_size: 12,
      col_size: 4,
      disable: false,
    },

    {
      name: "api_secret",
      label: "Api Secret",
      type: "text",
      showWhen: (values) =>
        values.broker === "1" ||
        values.broker === "2" ||
        values.broker === "3" ||
        values.broker === "4" ||
        values.broker === "5" ||
        values.broker === "6",

      label_size: 12,
      col_size: 4,
      disable: false,
    },

    {
      name: "parent_id",
      label: "Sub-Admin",
      type: "select",
      options:
        Addsubadmin.data &&
        Addsubadmin.data.map((item) => ({
          label: item.FullName,
          value: item._id,
        })),
      label_size: 12,
      col_size: 4,
      disable: false,
    },

    {
      name: "multiple_strategy_select",
      label: "Mutiple Selection Strategy",
      type: "checkbox",
      label_size: 12,
      col_size: 4,
      disable: false,
      check_box_true: formik.values.multiple_strategy_select ? true : false,
    },

    {
      name: "groupservice",
      label: "Group Service",
      type: "select",

      options:
        AllGroupServices.data &&
        AllGroupServices.data.map((item) => ({
          label: item.name,
          value: item._id,
        })),
      label_size: 12,
      col_size: 4,
      disable: false,
      madatory: true,
    },
  ];

  useEffect(() => {
    if (formik.values.licence === "2" || formik.values.licence === 2) {
      formik.setFieldValue("fromDate", null);
      formik.setFieldValue("todate", null);
    }
    if (formik.values.licence === "1" || formik.values.licence === 1) {
      formik.setFieldValue("tomonth", null);
      formik.setFieldValue("broker", null);
    }
    if (formik.values.licence === "0" || formik.values.licence === 0) {
      formik.setFieldValue("fromDate", null);
      formik.setFieldValue("todate", null);
    }
  }, [formik.values.broker, formik.values.licence]);

  useEffect(() => {
    if (UserData.data?.data?.[0].broker != formik.values.broker) {
      formik.setFieldValue("api_key", "null");

      formik.setFieldValue("api_secret", "null");
    }
  }, [formik.values.broker, UserData.data?.data?.[0].broker]);

  const getGroupeServics = async () => {
    if (formik.values.groupservice) {
      await dispatch(
        Get_Service_By_Group_Id({ _id: formik.values.groupservice })
      )
        .unwrap()
        .then((response) => {
          if (response.status) {
            setGetServices({
              loading: false,
              data: response.data,
            });
          }
        });
    }
  };
  useEffect(() => {
    getGroupeServics();
  }, [formik.values.groupservice]);

  // GET ALL GROUP SERVICES NAME / GET ALL SUBAMDIN / STRATEGY
  const data = async () => {
    await dispatch(GET_ALL_GROUP_SERVICES())
      .unwrap()
      .then((response) => {
        if (response.status) {
          setAllGroupServices({
            loading: false,
            data: response.data,
          });
        }
      });

    await dispatch(Get_All_SUBADMIN())
      .unwrap()
      .then((response) => {
        if (response.status) {
          setAddsubadmin({
            loading: false,
            data: response.data,
          });
        }
      });

    await dispatch(
      Get_All_Service_for_Client({
        req: {},
        token: user_details?.token,
      })
    )
      .unwrap()
      .then((response) => {
        if (response.status) {
          setAllStrategy({
            loading: false,
            data: response.data,
          });
        }
      });
  };

  //  For Checked Strategy
  const handleStrategyChange = (event) => {
    const strategyId = event.target.value;
    setSelectedStrategies((prevStrategies) => {
      return prevStrategies.map((strategy) =>
        strategy.id === strategyId
          ? { ...strategy, checked: !strategy.checked }
          : strategy
      );
    });
  };

  useEffect(() => {
    const userData = UserData.data?.data?.[0];

    if (userData) {
      formik.setFieldValue("username", userData.UserName);
      formik.setFieldValue("fullName", userData.FullName);
      formik.setFieldValue("email", userData.Email);
      formik.setFieldValue("mobile", userData.PhoneNo);
      formik.setFieldValue("licence", userData.license_type);
      formik.setFieldValue("licence1", userData.licence);
      formik.setFieldValue(
        "groupservice",
        userData.groupservices_clients?.groupService_id
      );
      formik.setFieldValue("broker", userData.broker);
      formik.setFieldValue("parent_id", userData.parent_id);
      formik.setFieldValue("app_id", userData.app_id);
      formik.setFieldValue("api_type", userData.api_type);
      formik.setFieldValue("client_code", userData.client_code);
      formik.setFieldValue("api_key", userData.api_key);
      formik.setFieldValue("api_secret", userData && userData.api_secret);
      formik.setFieldValue("app_key", userData.app_key);
      formik.setFieldValue("demat_userid", userData.demat_userid);
      formik.setFieldValue("todate", f_time(userData.EndDate));
      formik.setFieldValue("fromDate", f_time(userData.StartDate));
      formik.setFieldValue(
        "multiple_strategy_select",
        userData.multiple_strategy_select == "1"
      );
      formik.setFieldValue("plan_id", userData.plan_id);
    }
  }, [UserData.data]);

  useEffect(() => {
    if (UserData.data.strategy) {
      const initialSelectedStrategies = AllStrategy.data.map((strategy) => ({
        id: strategy._id,
        name: strategy.strategy_name,
        checked: UserData.data.strategy.some(
          (item) => item.strategy_id === strategy._id
        ),
      }));
      setSelectedStrategies(initialSelectedStrategies);
    }
  }, [UserData.data.strategy, AllStrategy.data]);

  if (selector && selector.permission) {
    if (
      selector.permission &&
      selector.permission.data &&
      selector.permission.data[0]
    ) {
      if (selector.permission.data[0].Two_day_client == 0) {
        fields = fields.map((field) => {
          if (field.name === "licence") {
            return {
              ...field,
              options: field.options.filter(
                (option) => option.label !== "2 Days"
              ),
            };
          }
          return field;
        });
      }
    }
  }

  useEffect(() => {
    if (UserData?.data?.data?.[0]?.EndDate) {
      const Service_Month_Arr = [];
      const currentDate =
        formik.values.licence == "2" || formik.values.licence === 2
          ? new Date(UserData.data.data[0].EndDate) > new Date()
            ? new Date(UserData.data.data[0].EndDate)
            : new Date()
          : new Date();

      for (let index = 1; index <= 1; index++) {
        // Adjust range as needed
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth();
        const endMonth = (currentMonth + index) % 12;
        const endYear = currentYear + Math.floor((currentMonth + index) / 12);

        const endDate = `${index} Month Licence Expires On ${currentDate.getDate()}-${
          endMonth + 1
        }-${endYear}`;
        Service_Month_Arr.push({ month: index, endDate });
      }
      setfirst(Service_Month_Arr);
    }
  }, [UserData?.data?.data]);

  return (
    <>
      <Content
        Page_title="Edit  Client"
        button_title="Back"
        route="/admin/allclients"
        showEdit={true}
        show_Stat_End_date={
          UserData.data.data !== undefined && UserData.data.data[0]
        }
      >
        <Formikform
          fieldtype={fields.filter(
            (field) => !field.showWhen || field.showWhen(formik.values)
          )}
          formik={formik}
          btn_name="Update"
          fromDate={formik.values.fromDate}
          toDate={formik.values.todate}
          additional_field={
            <>
              {/*  For Show All Services */}
              <h6 className="mt-4 fw-semibold">All Group Services</h6>

              <div className="d-flex flex-wrap gap-2 mt-3 mb-3">
                {GetServices &&
                  GetServices.data.map((strategy) => (
                    <span
                      key={strategy._id}
                      style={{ fontSize: "0.75rem" }}
                      className=" rounded-pill border px-3 py-2 fw-medium"
                    >
                      {strategy.ServiceResult.name} 
                    </span>
                  ))}
              </div>

              <hr />
              <h6>
                All Strategy <span className="text-danger">*</span>
              </h6>

              <div className="row">
                {selectedStrategies.map((strategy) => (
                  <div className={`col-lg-2 col-4 mt-2`} key={strategy.id}>
                    <div className="row ">
                      <div className="col-lg-12 ">
                        <div className="form-check custom-checkbox mb-3">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            name={strategy.id}
                            value={strategy.id}
                            onChange={(e) => handleStrategyChange(e)}
                            checked={strategy.checked}
                          />
                          <label
                            className="ms-1 form-check-label"
                            htmlFor={strategy.name}
                          >
                            {strategy.name}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          }
        />
        <ToastButton />
      </Content>
    </>
  );
};
export default EditClient;
